import { render, staticRenderFns } from "./reportDetails.vue?vue&type=template&id=4b06b634&scoped=true&"
import script from "./reportDetails.vue?vue&type=script&lang=ts&"
export * from "./reportDetails.vue?vue&type=script&lang=ts&"
import style0 from "./reportDetails.vue?vue&type=style&index=0&id=4b06b634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b06b634",
  null
  
)

export default component.exports